import { createSelector } from '@reduxjs/toolkit'
import { Store } from '../types'

export const appSelector = (store: Store) => store.app
export const appLanguageSelector = createSelector(appSelector, state => state.language)
